import { render } from "./great-job.vue?vue&type=template&id=1251052e&scoped=true"
import script from "./great-job.vue?vue&type=script&lang=js"
export * from "./great-job.vue?vue&type=script&lang=js"

import "./great-job.vue?vue&type=style&index=0&id=1251052e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1251052e"]])

export default __exports__